export function onClientMode(callback) {
  if (import.meta.env.SSR) {
    return;
  }
  return callback();
}
